import { ArrowUpRight, Asterisk } from "lucide-react";
import { Reveal } from "./Reveal";

const PARTNERS = [
  {
    id: "amazon",
    href: "https://advertising.amazon.com/partners/directory/details/amzn1.ads1.ma1.c1doroals8gqwv1iend510raa/DSA-eCommerce-LLC?sref_=suggestion",
    wordmark: (
      <span className="font-display text-3xl font-black lowercase tracking-tight text-ink">
        amazon<span className="text-[#FF9900]">ads</span>
      </span>
    ),
    status: "Verified Partner",
    action: "Find us on Amazon",
  },
  {
    id: "walmart",
    href: "https://marketplace.walmart.com/solution-providers-old/dsaecommerce/",
    wordmark: (
      <span className="flex items-center gap-1.5 font-display text-3xl font-black tracking-tight text-[#0071CE]">
        Walmart
        <Asterisk className="h-6 w-6 text-[#FFC220]" strokeWidth={3} />
      </span>
    ),
    status: "Marketplace Solution Provider",
    action: "Find us on Walmart",
  },
];

export function PartnerStrip() {
  return (
    <section data-testid="partner-strip" className="border-t border-black/10 bg-white">
      <div className="mx-auto flex max-w-[1600px] flex-wrap items-center gap-x-12 gap-y-8 px-5 py-14 md:px-10">
        <Reveal className="shrink-0">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-signal">
            Official & verified
          </p>
          <p className="mt-2 font-display text-xl font-bold tracking-tight">
            Partner status
          </p>
        </Reveal>
        {PARTNERS.map((p, i) => (
          <Reveal key={p.id} delay={0.1 + i * 0.1}>
            <a
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`partner-${p.id}-button`}
              className="group flex items-center gap-6 border border-black/10 bg-[#F4F2EC] px-8 py-5 transition-colors duration-200 hover:border-ink"
            >
              <div>
                {p.wordmark}
                <p className="mt-1 font-mono2 text-[10px] uppercase tracking-[0.2em] text-ink/50">
                  {p.status}
                </p>
              </div>
              <span className="flex items-center gap-2 border-l border-black/10 pl-6 font-mono2 text-[11px] uppercase tracking-[0.15em] text-ink/60 transition-colors duration-200 group-hover:text-signal">
                {p.action}
                <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
